// frontend/src/components/cookies/CookieBanner.jsx
import { useState } from "react";
import { useCookies } from "../../context/CookieContext";
import CookieSettings from "./CookieSettings";
import { Cookie, Settings, CheckCircle } from "lucide-react";

export default function CookieBanner() {
  const { hasAccepted, acceptAll } = useCookies();
  const [showSettings, setShowSettings] = useState(false);

  if (hasAccepted) return null;

  return (
    <>
      {/* Banner de cookies - Centrado en desktop, ancho completo en mobile */}
      <div className="fixed bottom-0 left-0 right-0 z-50 flex justify-center">
        <div className="w-full md:max-w-lg md:mb-4 md:rounded-2xl md:shadow-2xl animate-slide-up">
          <div className="bg-white rounded-t-2xl md:rounded-2xl shadow-lg md:shadow-2xl border border-gray-200 overflow-hidden">
            <div className="bg-[#449879] px-4 py-3 flex items-center gap-2">
              <Cookie className="w-5 h-5 text-white" />
              <h3 className="text-white font-semibold text-sm">Utilizamos cookies</h3>
            </div>

            <div className="p-4">
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Utilizamos cookies para melhorar sua experiência, garantir o funcionamento da
                plataforma e analisar sua utilização.
              </p>

              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={acceptAll}
                  className="flex-1 bg-[#449879] text-white py-2.5 rounded-xl font-medium hover:bg-[#2d5f4d] transition-colors flex items-center justify-center gap-2"
                >
                  <CheckCircle className="w-4 h-4" />
                  Aceitar
                </button>
                <button
                  onClick={() => setShowSettings(true)}
                  className="flex-1 border border-gray-300 text-gray-700 py-2.5 rounded-xl font-medium hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
                >
                  <Settings className="w-4 h-4" />
                  Configurar Preferências
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CookieSettings isOpen={showSettings} onClose={() => setShowSettings(false)} />
    </>
  );
}